import { RHF } from "@/shared/forms";
import { Label } from "@/components/ui/label";
import { Slider } from "@/components/ui/slider";



export const BRANCH_RADIUS_SLIDER_MAX = 20_000;
export const BRANCH_RADIUS_SLIDER_STEP = 100;

type BranchRadiusSliderProps = {
  value: number;
  onChange: (value: number) => void;
  id?: string;
  label?: string;
  showValue?: boolean;
  className?: string;
};

/** Radius slider — shadcn/Radix `Slider` local */
export function BranchRadiusSlider({
  value,
  onChange,
  id = "branch-radius-slider",
  label = "ລັດສະໝີ (ແມັດ)",
  showValue = true,
  className,
}: BranchRadiusSliderProps) {
  const clamped = Math.min(Math.max(0, value), BRANCH_RADIUS_SLIDER_MAX);

  return (
    <div className={className}>
      <div className="mb-3 flex items-center justify-between gap-2">
        <Label htmlFor={id}>{label}</Label>
        {showValue ? (
          <span className="text-muted-foreground text-sm tabular-nums">
            {clamped.toLocaleString()} ມ.
          </span>
        ) : null}
      </div>
      <Slider
        id={id}
        min={0}
        max={BRANCH_RADIUS_SLIDER_MAX}
        step={BRANCH_RADIUS_SLIDER_STEP}
        value={[clamped]}
        onValueChange={(values) => onChange(values[0] ?? 0)}
        className="w-full"
      />
    </div>
  );
}

/** ใช้ใน FormRoot — sync กับ `serviceRadiusM` */
export function BranchRadiusSliderField({
  name = "serviceRadiusM",
}: {
  name?: string;
}) {
  const { watch, setValue } = RHF.useFormContext<{
    serviceRadiusM?: number;
  }>();
  const radius = watch(name as "serviceRadiusM") ?? 0;

  return (
    <BranchRadiusSlider
      value={radius}
      onChange={(v) =>
        setValue(name as "serviceRadiusM", v, {
          shouldDirty: true,
          shouldValidate: true,
        })
      }
    />
  );
}
